import { MessageEntity, 
         DialogEntity,
         MessageFactory,
         IAttachment,
         AttachmentTypeEnum }                    from '../..';
import { ServerConnector, ConfigService, toHttpRequest }  from '../../../';


/**
 * The service that implements the functions related to dialog initialization and 
 * association to messages giving the user conversation flow depending on the disambiguation 
 * or decision tree button selection.
 */
export class DialogService { 

    /**
     * Initialize a new dialog for the current conversation session.
     */
    public static initializeNewDialog(): DialogEntity | null {
        const dialog: DialogEntity | null = null;
        return dialog;
    }

    /**
     * Parse BotServer answer and returns the associated Message entities and their
     * associated attachments.
     * 
     * @param botActivities - The bot server answer related to a user message
     */
    public static getMessagesFromBotAnswer(botActivities: any[]): MessageEntity[] {
        return MessageFactory.buildMessageEntitiesFromBotAnswer(botActivities);
    }

    /**
     * Extract emotion to play from message attachments.
     * 
     * @param messages - The messages returned by the server.
     */
    public static getMessagesEmotionToPlay(messages: MessageEntity[]): string | undefined {
        let emotionToPlay: string | undefined;
        messages.forEach((message: MessageEntity) => {
            // if we have several messages with an emotion attachment, only the latest emotion attachment is taken into account
            const attachments: Map<number, IAttachment[]> | undefined = message.attachments;
            if (attachments) {
                const emoAtts: IAttachment[] | undefined = attachments.get(AttachmentTypeEnum.EMOTION);
                if (emoAtts) {
                    emotionToPlay = emoAtts[0].attId; // only one emotion is sent by message
                    emotionToPlay = emotionToPlay.substr(0, emotionToPlay.indexOf('-'));
                }
            }
        });
        return emotionToPlay;
    }
    
    /**
     * Counts different answer citations in the bot's message HTML.
     * @param html - The HTML string of the bot's message
     * @returns List of unique answer IDs found in the HTML
     */
    public static getUniqueCitationsFromHtml(html: string): number[] {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const links = doc.querySelectorAll('a[data-answer-id]');
        const uniqueAnswerIds = new Set<number>();
    
        links.forEach(link => {
            const answerIdStr = link.getAttribute('data-answer-id');
            if (answerIdStr) {
                const answerId = parseInt(answerIdStr, 10);
                if (!isNaN(answerId)) {
                    uniqueAnswerIds.add(answerId);
                }
            }
        });
    
        return Array.from(uniqueAnswerIds);
    }

   

}
